import { Injectable } from '@angular/core';
import { combineLatestWith, map, Observable } from 'rxjs';
import { BannerSlide } from './banner-slide.interface';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import { AdditionalPagesRepository } from '../../shared/repositories/additional-pages.repository';

@Injectable({
  providedIn: 'root'
})
export class BannerSliderService {
  constructor(
    private config: ConfigRepository,
    private additionalPageRepository: AdditionalPagesRepository,
  ) {}

  banners$: Observable<BannerSlide[]> = this.additionalPageRepository.promotions$.pipe(
    combineLatestWith(this.config.bannerUrls$),
    map(([promotions, bannerUrls]) => {
      if(!promotions){return []}

      const bannerSlides: BannerSlide[] = [];
      promotions.forEach(promotion => {
        if(promotion.isShowBannerHomePage && promotion.bannerImageUrl){
          bannerSlides.push({
            //TODO: EC-2051 replace to only promotion.bannerImageUrl after https://jira.iiko.ru/browse/EC-2049
            bannerImageUrl: {src: promotion.bannerImageUrl},
            slug: promotion.slug,
            priority: promotion.priority,
            title: promotion.title
          })
        }
      })

      if(bannerUrls) {
        bannerUrls.forEach(url => {
          bannerSlides.push({
            //TODO: EC-2051 replace to only url after https://jira.iiko.ru/browse/EC-2049
            bannerImageUrl: {src: url},
            slug: null,
            priority: Infinity,
            title: ''
          })
        })
      }

      return bannerSlides;
    }),
    map(bannerSlides => bannerSlides.sort((a, b) => a.priority > b.priority ? 1 : -1))
  )
}
